import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function runFundingReadiness(clientId, agencyId) {
  return fundingHqFetch(`/clients/${encodeURIComponent(clientId)}/readiness?${agencyQuery(agencyId)}`, {
    method: 'POST',
  });
}

export async function fetchFundingReadiness(clientId, agencyId) {
  return fundingHqFetch(`/clients/${encodeURIComponent(clientId)}/readiness?${agencyQuery(agencyId)}`);
}

export async function fetchFundingReadinessChecks({ agencyId, limit = 50 } = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/readiness${query ? `?${query}` : ''}`);
  return {
    checks: data.checks ?? [],
    total: data.total ?? (data.checks?.length ?? 0),
  };
}
